/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Source_LanguageInputs */

const en_source_language = /** @type {(inputs: Source_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source Language`)
};

const fr_source_language = /** @type {(inputs: Source_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langue source`)
};

const de_source_language = /** @type {(inputs: Source_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgangssprache`)
};

const it_source_language = /** @type {(inputs: Source_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lingua di origine`)
};

const ru_source_language = /** @type {(inputs: Source_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Исходный язык`)
};

const es_source_language = /** @type {(inputs: Source_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma de origen`)
};

const zh_cn2_source_language = /** @type {(inputs: Source_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`源语言`)
};

const ja_source_language = /** @type {(inputs: Source_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソース言語`)
};

const hi_source_language = /** @type {(inputs: Source_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्रोत भाषा`)
};

const pt_pt2_source_language = /** @type {(inputs: Source_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Língua de origem`)
};

/**
* | output |
* | --- |
* | "Source Language" |
*
* @param {Source_LanguageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const source_language = /** @type {((inputs?: Source_LanguageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Source_LanguageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_source_language(inputs)
	if (locale === "de") return de_source_language(inputs)
	if (locale === "it") return it_source_language(inputs)
	if (locale === "ru") return ru_source_language(inputs)
	if (locale === "es") return es_source_language(inputs)
	if (locale === "zh-CN") return zh_cn2_source_language(inputs)
	if (locale === "ja") return ja_source_language(inputs)
	if (locale === "hi") return hi_source_language(inputs)
	if (locale === "pt-PT") return pt_pt2_source_language(inputs)
	return en_source_language(inputs)
});